import { AsyncAction } from '../../base-classes';
import { MapFeatureDetailsProvider } from '../providers/mapFeatureDetailsProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_MAP_FEATURE_DETAILS = new AsyncAction('GET_MAP_FEATURE_DETAILS');

export function getFeatureDetails(...params) {
    let paramsObject = {
        featureId: undefined,
        slotId: undefined,
        layerId: undefined,
        temperatureUnit: undefined,
        cultureInfo: undefined,
        stdParameters:undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        refresh: undefined,
        options: undefined,
        logger: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_MAP_FEATURE_DETAILS.base,
        payload: getFeatureDetailsAction(paramsObject)
    };
}

async function getFeatureDetailsAction({ featureId, slotId, layerId, baseUrl, authId, secret, options, logger, temperatureUnit, cultureInfo, stdParameters, verbose, refresh }) {
    const op = new MapFeatureDetailsProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getMapFeatureDetails(layerId, slotId, featureId, temperatureUnit, cultureInfo, stdParameters, verbose, refresh);
    return results;
}
